export const msDocRendererStyles = { minHeight: '450px', minWidth: '400px' };

export const pdfDocRendererStyles = { minHeight: '450px', minWidth: '400px' };
